import { render, staticRenderFns } from "./CadreDrawer.vue?vue&type=template&id=53a4a6bd&scoped=true"
import script from "./CadreDrawer.vue?vue&type=script&lang=js"
export * from "./CadreDrawer.vue?vue&type=script&lang=js"
import style0 from "./CadreDrawer.vue?vue&type=style&index=0&id=53a4a6bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a4a6bd",
  null
  
)

export default component.exports